import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ManagementApiService } from 'src/app/services';
import { NotificationAck, Notifications } from 'src/app/models/Notifications.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-terms-condition',
    templateUrl: './terms-condition.component.html',
    styleUrls: ['./terms-condition.component.scss'],
})
export class TermsConditionComponent implements OnInit {
    @Input() notification: Notifications;
    disabledControl: boolean;
    checkbox = new UntypedFormControl(false, Validators.required);

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private managementService: ManagementApiService,
        private customToastService: CustomToastService
    ) {
        this.disabledControl = true;
    }

    ngOnInit(): void {
        this.checkbox.disable();
    }

    // * modal scroll handler
    scrollHandler() {
        let scrollTopValue = document.querySelector('.terms-modal-body').scrollTop;
        let scrollHeight = document.querySelector('.terms-modal-body').scrollHeight;

        if (scrollHeight - scrollTopValue < 500) {
            this.disabledControl = false;
            this.checkbox.enable();
        } else {
            this.disabledControl = true;
            this.checkbox.disable();
        }
        // this.checkbox.disable({onlySelf : this.disabledControl, emitEvent: true});
    }

    // * accept button click handler
    acceptButtonsClick() {
        let payload = new NotificationAck();
        if (this.checkbox.value) {
            payload.actioned = true;
            payload.userNotificationId = this.notification.notifiers[0].userNotificationId;
            this.managementService.updateNotification([payload]).subscribe(
                (res) => {
                    this.ngbActiveModal.close();
                    if (res.success) {
                        this.customToastService.successToast('Succesfully! Notified your Notification.', 'Success');
                    }
                },
                (err) => {}
            );
            // this.ngbActiveModal.close();
        } else {
            this.checkbox.markAsDirty();
        }
    }
}
